import React from 'react'
import Dashboard from './components/Dashboard'
import './index.css'

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <div className="container-full">
        <Dashboard />
      </div>
    </div>
  )
}

export default App